import { Content } from '@radix-ui/react-context-menu'
import styled from 'styled-components'

export const StyledNewContextMenuContent = styled(Content)`
  min-width: 200px;
  background-color: ${props => props.theme.colors.background.base};
  border-radius: ${props => props.theme.dimensions.borderRadius};
  padding: ${props => props.theme.spacings.small};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
`
